import clsx from 'clsx';
import React from 'react';
import { FiX } from 'react-icons/fi';

export interface FilterBadgeProps {
  label: string;
  onRemove?: () => void;
  className?: string;
}

export const FilterBadge: React.FC<FilterBadgeProps> = ({ label, onRemove, className }) => {
  return (
    <div
      className={clsx(
        'inline-flex items-center gap-2 px-3 py-1.5 bg-purple-100 text-purple-700 rounded-full text-sm font-medium',
        className
      )}
    >
      <span>{label}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="hover:bg-purple-200 rounded-full p-0.5 transition-colors"
          aria-label="Remover filtro"
        >
          <FiX className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
